import {Component, EventEmitter, Input, Output} from "@angular/core";
import {TreeNode} from "@app/modules/models";

@Component({
  selector: "app-browse-sidebar",
  templateUrl: "./browse-sidebar.component.html",
  styleUrls: ["./browse-sidebar.component.scss"],
})
export class BrowseSidebarComponent {
  @Input() nodes: TreeNode[];
  @Input() selectedNode: TreeNode = null;
  @Input() nodesLoading: boolean = null;
  @Output() closeIconClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectedNodeChange: EventEmitter<TreeNode> = new EventEmitter<TreeNode>();

  onCloseIconClick(): void {
    this.closeIconClick.emit();
  }

  onNodeClick(node: TreeNode): void {
    this.selectedNodeChange.emit(node);
  }

  trackByParentNode(index: number, parentNode: TreeNode): string {
    return parentNode.label;
  }

  isNodeSelected(node: TreeNode): boolean {
    return node?.label === this.selectedNode?.label;
  }
}
